"use client";
import clsx from "clsx";
import { ProductOption } from "@/lib/medusa/types";
import LoadingDots from "@/components/loading-dots";

export async function VariantSelectorSkeleton({
  options,
}: {
  options: ProductOption[];
}) {
  return (
    <>
      {options.length === 1
        ? null
        : options.map((option) => (
            <dl className="mb-8" key={option.id}>
              <dt className="mb-4 text-sm uppercase tracking-wide">
                {option.name}
              </dt>
              <dd className="flex flex-wrap gap-3">
                {option.values.map((value) => {
                  return (
                    <p
                      key={value}
                      className={clsx(
                        "animate-pulse min-w-[48px] flex items-center justify-center bg-neutral-500 dark:bg-neutral-800 text-neutral-500 dark:text-neutral-800 rounded-full border px-2 py-1 dark:border-neutral-800 text-sm"
                      )}
                    >
                      {value}
                    </p>
                  );
                })}
              </dd>
            </dl>
          ))}
      <button
        disabled
        onClick={() => {}}
        className="animate-pulse relative flex disabled:opacity-60 disabled:cursor-not-allowed w-full items-center justify-center rounded-full bg-blue-600 p-4 tracking-wide text-white hover:opacity-90"
      >
        <div className="absolute left-0 ml-4">
          <LoadingDots className="mb-3 bg-white" />
        </div>
        <span>Készlet betöltése</span>
      </button>
    </>
  );
}
